import { CRM_MENU, CRM_CURRENT_LEVEL_ONE_MENU, CRM_USER_INFO } from './keys';
import { GetContactByUid, ccValidToken, sendCall } from '../api/callCenter';
// 拨打电话按钮取消禁止点击
export function pointerEvents() {
    let arrCall = document.querySelectorAll('.pointer-events');
    arrCall.forEach(item => {
        item.classList.remove('pointer-events');
    })
}

//获取阿里呼叫状态
export function getCallStatus(self) {
    setTimeout(() => {
        let callStatus = window.workbench.getStatusCode();
        self.$store.dispatch("setCallStatus", callStatus.code);
    }, 300);
}
//电话接听
export function answerCall(self) {
    window.workbench.answer();
}
//挂断电话
export function hangupCall(self, extNo) {
    self.$store.dispatch('hangupCall', { "ExtNO": extNo });
}
//阿里拨打电话
export function aliCCCall(uInfo, to) {
    pointerEvents();
    if (!uInfo) {
        Message({
            message: '请联系管理员配置呼叫中心',
            showClose: true,
            type: 'warning'
        });
    }
    var status = window.workbench.getStatusCode();
    console.log("ali status:" + status);
    if (status) {
        if (status.code == 1 || status.code == 0) {
            window.workbench.logIn();
        } else if (status.code == 8) {
            window.workbench.hangUp();
        }
    }
    setTimeout(() => {
        if (!uInfo.MqPhone) {
            window.workbench.call(to);
        } else {
            window.workbench.call(to, uInfo.MqPhone);
        }

    }, 500);
}
//阿里云CC话务状态
export function signAliYunCC(operate) {
    pointerEvents();
    switch (operate) {
        case 1: //签入
            window.workbench.logIn();
            break;
        case 2: //签出
            window.workbench.logOut();
            break;
        case 3: //置忙
            window.workbench.applyForBreak();
            break;
        case 4: //置闲
            window.workbench.ready();
            break;
    }
}

function tianrunCCLogin() {
    pointerEvents();
    let userInfo = JSON.parse(localStorage.getItem(CRM_USER_INFO));
    var params = {
        hotLine: userInfo.TrHotLine,
        cno: userInfo.TrAgentNo,
        pwd: userInfo.TrPwd,
        bindTel: userInfo.TrBindTel,
        bindType: "1",
        initStatus: "online"
    };
    window.executeAction('doLogin', params); //执行登陆 
}

//天润云CC话务状态
export function signTianRunYunCC(operate) {
    pointerEvents();
    switch (operate) {
        case 1: //签入
            tianrunCCLogin()
            break;
        case 2: //签出
            window.executeAction("doLogout", { "type": "1" });
            break;
        case 3: //置忙
            window.executeAction('doPause', { "description": "置忙" });
            break;
        case 4: //置闲
            window.executeAction('doUnpause');
            break;
    }
}

let oCallStatus = {
    _statusMsg(self, msg) { // 拨打电话状态提示
        self.$message({
            message: msg,
            type: 'warning'
        });
        pointerEvents();
        return;
    },
    callccValidToken(userInfo, phoneNum, Guid) { // 天润云CC接口
        ccValidToken({ "userId": userInfo.UserId }).then(ret => {
            aliCCCall(userInfo.SysAliyunMq ? userInfo.SysAliyunMq[0] : null, phoneNum, Guid);
        }).catch(() => {
            aliCCCall(userInfo.SysAliyunMq ? userInfo.SysAliyunMq[0] : null, phoneNum, Guid);
        });
    },
    tianRunCCCall(to, vself) { //天润拨打电话
        pointerEvents();
        if (!vself.$store.state.navigation.trCCEventName) {
            if (window.executeAction) {
                tianrunCCLogin();
            }
        }
        setTimeout(() => {
            window.executeAction('doPreviewOutCall', {
                "tel": to,
                "callType": "3"
            });
        }, 1000);
    }
}

// 进入拨打电话
function oSendCall(self, mobile, userInfo, Guid, Uid, phoneType) {
    let queryParm = { UserNo: userInfo.UserId, ExtNo: userInfo.PartialPhone };
    if (mobile.indexOf('*') == -1) { // 明文电话
        let phoneNum = '';
        if (mobile.substring(0, 2) == '01' && mobile.substring(0, 2) !== '010') {
            phoneNum = mobile.slice(1, mobile.length);
        } else {
            phoneNum = mobile
        }
        if (!phoneNum) {
            return;
        }
        if (userInfo.CallCenterType == 2) {
            oCallStatus.callccValidToken(userInfo, phoneNum, Guid);
        } else if (userInfo.CallCenterType == 3) {
            oCallStatus.tianRunCCCall(phoneNum, self);
        } else {
            self.$store.dispatch('callUp', {
                UserNo: userInfo.UserId,
                FromNo: userInfo.PartialPhone,
                ToNo: phoneNum,
                ClueId: Guid,
                ClueGuid: Guid,
            })
        }
        setTimeout(() => {
            self.$store.dispatch('getExtStatus', queryParm);
        }, 2000);
    } else { // 隐码电话
        let sendCall = {
            Uid,
            mobile,
            phoneType
        }
        GetContactByUid(sendCall).then(ret => { // 获取手机号码明文
            if (ret.status === 0) {
                let phoneNum = '';
                if (ret.result.substring(0, 2) == '01' && ret.result.substring(0, 2) !== '010') {
                    phoneNum = ret.result.slice(1, ret.result.length);
                } else {
                    phoneNum = ret.result
                }
                if (!phoneNum) {
                    return;
                }
                if (userInfo.CallCenterType == 2) {
                    oCallStatus.callccValidToken(userInfo, phoneNum, Guid);
                } else if (userInfo.CallCenterType == 3) {
                    oCallStatus.tianRunCCCall(phoneNum, self);
                } else {
                    self.$store.dispatch('callUp', {
                        UserNo: userInfo.UserId,
                        FromNo: userInfo.PartialPhone,
                        ToNo: phoneNum.replace('-', ''),
                        ClueId: Guid,
                        ClueGuid: Guid,
                    })
                }
            } else {
                oCallStatus._statusMsg(self, '拨打电话失败，请稍后再试');
            }
        }).catch(() => {
            oCallStatus._statusMsg(self, '拨打电话失败，请稍后再试');
        });
    }
}


/*
 * 拨打电话全局方法
 */
export default {
    install(Vue, options) {
        Vue.prototype.getCallUps = (self, Uid, mobile, phoneType, CustomGuid, Guid) => {
            let userInfo = JSON.parse(localStorage.getItem(CRM_USER_INFO));
            self.$store.dispatch("setCallInfo", 0); //将通话ID置为0

            let callStatus = self.$store.state.navigation.extStatusId;
            if (Guid && callStatus == 2 && !self.$store.state.cluesManage.isTracking) {
                let trackingGuid = {
                    CustomGuid,
                    Guid,
                    Uid
                }
                self.$store.dispatch('isTracking', true);
                self.$store.dispatch('getTrackingIds', trackingGuid);
            }
            switch (callStatus) {
                case 1:
                    oCallStatus._statusMsg(self, '请先签入,再拨打电话');
                    break;
                case 2: // 拨打电话
                    oSendCall(self, mobile, userInfo, Guid, Uid, phoneType);
                    break;
                case 3:
                    oCallStatus._statusMsg(self, '请先置闲，再拨打电话');
                    break;
                case 4:
                    oCallStatus._statusMsg(self, '通话中, 请稍后再试');
                    break;
                default:
                    oCallStatus._statusMsg(self, '服务未处理异常');
                    break;
            }
        }
    }
}